var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03125 11.8125C2 11.8125 0.375 10.1875 0.375 8.15625C0.375 6.58203 1.39062 5.21094 2.8125 4.72852C2.8125 4.65234 2.8125 4.57617 2.8125 4.5C2.8125 2.26562 4.61523 0.4375 6.875 0.4375C8.37305 0.4375 9.69336 1.27539 10.3789 2.49414C10.7598 2.21484 11.2422 2.0625 11.75 2.0625C13.0957 2.0625 14.1875 3.1543 14.1875 4.5C14.1875 4.83008 14.1113 5.10938 14.0098 5.38867C15.5078 5.69336 16.625 7.01367 16.625 8.5625C16.625 10.3652 15.1523 11.8125 13.375 11.8125H4.03125ZM8.06836 9.60352C8.29688 9.85742 8.67773 9.85742 8.90625 9.60352L10.9375 7.57227C11.1914 7.34375 11.1914 6.96289 10.9375 6.70898C10.709 6.48047 10.3281 6.48047 10.0996 6.70898L9.10938 7.72461V4.29688C9.10938 3.9668 8.83008 3.6875 8.5 3.6875C8.14453 3.6875 7.89062 3.9668 7.89062 4.29688V7.72461L6.875 6.70898C6.64648 6.48047 6.26562 6.48047 6.03711 6.70898C5.7832 6.96289 5.7832 7.34375 6.03711 7.57227L8.06836 9.60352Z",
    fill: "inherit",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudArrowDown);
export default __webpack_public_path__ + "static/media/cloud-arrow-down.fbf5b69a3d3c016447d2632e0b4facfb.svg";
export { ForwardRef as ReactComponent };